(() => {
  const root = document.querySelector('[data-es-create][data-es-set]');
  const ui = root && root.querySelector('[data-es-pull-ui]');
  if (!root || !ui) return;

  const PATH = ['gift', 'bounce', 'diagnosis', 'name', 'room', 'face', 'chips', 'line', 'genre', 'sound', 'contact'];
  const SKINS = {
    Generic: {
      recipient: 'Other',
      cookie: 'Generic',
      gifts: {
        watch: { label: 'A watch', phrase: 'a watch' },
        wallet: { label: 'A wallet', phrase: 'a wallet' },
        cologne: { label: 'Something they wear', phrase: 'something they wear' },
        grill: { label: 'A dinner', phrase: 'a dinner' },
        tools: { label: 'A trip', phrase: 'a trip' },
        nothing: { label: 'Nothing they would open', phrase: 'anything you wrap' },
        other: { label: 'Something else', phrase: 'another thing' },
      },
      bounces: {
        thanked: { label: 'Thanked you', phrase: 'thanked me' },
        joked: { label: 'Joked it off', phrase: 'joked it off' },
        nothing: { label: 'Said they wanted nothing', phrase: 'said they wanted nothing' },
      },
      rooms: {
        kitchen: 'the kitchen, on an ordinary night',
        car: 'the car, just the two of you',
        dinner: 'after dinner, when the house is quiet',
        together: 'just the two of you, no audience',
        party: 'in front of everyone who loves them',
      },
      faces: {
        quiet: 'They go quiet',
        joke: 'They start a joke and cannot finish it',
        again: 'They ask you to play it again',
      },
      chips: [
        { text: 'They never ask for anything', kind: 'quality' },
        { text: 'They make us feel safe', kind: 'quality' },
        { text: 'How we met', kind: 'memory' },
        { text: 'Something only I would know', kind: 'memory' },
      ],
      copy: {
        listen_lead: 'These are songs we already wrote for someone else.',
        listen: 'Yours gets their name, and the thing you never said.',
        gift_title: 'What did you get them last year?',
        gift_watch: 'A watch',
        gift_wallet: 'A wallet',
        gift_cologne: 'Something they wear',
        gift_grill: 'A dinner',
        gift_tools: 'A trip',
        gift_nothing: 'Nothing they would open',
        gift_other: 'Something else',
        gift_other_label: 'What did you get them?',
        gift_other_placeholder: 'A jacket, a trip, a weekend…',
        gift_other_cta: 'That’s it',
        bounce_title: 'And what did they do?',
        bounce_thanked: 'Thanked you',
        bounce_joked: 'Joked it off',
        bounce_nothing: 'Said they wanted nothing',
        diag_title: 'They would not know how to thank you for a song about them.',
        diag_cta: 'That’s them',
        name_title: 'What do we call them in the song?',
        name_placeholder: 'Their first name',
        name_cta: 'Use this name',
        room_title: 'Where should they hear it first?',
        room_lede: 'Not under the tree. In a room, when they cannot walk away.',
        face_title: 'What do you want to see when it lands?',
        face_quiet: 'They go quiet',
        face_joke: 'They start a joke and cannot finish it',
        face_again: 'They ask you to play it again',
        chips_title: 'Tap what you never actually said to them.',
        chips_lede: 'These go in the song. Skip anything that isn’t them.',
        missed_placeholder: 'A detail only you would know',
        line_title: 'The one thing you want them to hear.',
        line_placeholder: 'The thing you have been sitting on',
        genre_title: 'What should their song sound like?',
        sound_title: 'Who should sing this to them?',
        contact_title: 'Where do we send their preview?',
        contact_lede: 'Free in ten minutes. Musicians finish it with you.',
        submit: 'Write their song',
      },
      thankNothing: 'They never wanted a thing you could wrap.',
      thankLead: 'They can thank you for ',
      lastYear: 'Last year I got them ',
      andDid: ' and they ',
      hearRoom: 'They will hear this in ',
      validateGift: 'Tell us what you got them.',
      validateBounce: 'Tell us what they did.',
    },
    GratitudeWife: {
      recipient: 'Husband',
      cookie: 'GratitudeWife',
      gifts: {
        watch: { label: 'A watch', phrase: 'a watch' },
        wallet: { label: 'A wallet', phrase: 'a wallet' },
        cologne: { label: 'Cologne', phrase: 'cologne' },
        grill: { label: 'A grill', phrase: 'a grill' },
        tools: { label: 'Tools', phrase: 'tools' },
        nothing: { label: 'Nothing he would open', phrase: 'anything you wrap' },
        other: { label: 'Something else', phrase: 'another thing' },
      },
      bounces: {
        thanked: { label: 'Thanked you', phrase: 'thanked me' },
        joked: { label: 'Joked it off', phrase: 'joked it off' },
        nothing: { label: 'Said he wanted nothing', phrase: 'said he wanted nothing' },
      },
      rooms: {
        kitchen: 'the kitchen, on an ordinary night',
        car: 'the car, just the two of you',
        dinner: 'after dinner, when the house is quiet',
        together: 'just the two of you, no audience',
        party: 'in front of everyone who loves him',
      },
      faces: {
        quiet: 'He goes quiet',
        joke: 'He starts a joke and cannot finish it',
        again: 'He asks you to play it again',
      },
      chips: [
        { text: 'He never asks for anything', kind: 'quality' },
        { text: 'He makes us feel safe', kind: 'quality' },
        { text: 'How we met', kind: 'memory' },
        { text: 'Something only I would know', kind: 'memory' },
      ],
      copy: {
        listen_lead: 'These are songs we already wrote for someone else.',
        listen: 'Yours gets his name, and the thing you never said.',
        gift_title: 'What did you get him last year?',
        gift_watch: 'A watch',
        gift_wallet: 'A wallet',
        gift_cologne: 'Cologne',
        gift_grill: 'A grill',
        gift_tools: 'Tools',
        gift_nothing: 'Nothing he would open',
        gift_other: 'Something else',
        gift_other_label: 'What did you get him?',
        gift_other_placeholder: 'A jacket, a trip, a tool set…',
        gift_other_cta: 'That’s it',
        bounce_title: 'And what did he do?',
        bounce_thanked: 'Thanked you',
        bounce_joked: 'Joked it off',
        bounce_nothing: 'Said he wanted nothing',
        diag_title: 'He would not know how to thank you for a song about him.',
        diag_cta: 'That’s him',
        name_title: 'What do we call him in the song?',
        name_placeholder: 'His first name',
        name_cta: 'Use this name',
        room_title: 'Where should he hear it first?',
        room_lede: 'Not under the tree. In a room, when he cannot walk away.',
        face_title: 'What do you want to see when it lands?',
        face_quiet: 'He goes quiet',
        face_joke: 'He starts a joke and cannot finish it',
        face_again: 'He asks you to play it again',
        chips_title: 'Tap what you never actually said to him.',
        chips_lede: 'These go in the song. Skip anything that isn’t him.',
        missed_placeholder: 'A detail only you would know',
        line_title: 'The one thing you want him to hear.',
        line_placeholder: 'The thing you have been sitting on',
        genre_title: 'What should his song sound like?',
        sound_title: 'Who should sing this to him?',
        contact_title: 'Where do we send his preview?',
        contact_lede: 'Free in ten minutes. Musicians finish it with you.',
        submit: 'Write his song',
      },
      thankNothing: 'He never wanted a thing you could wrap.',
      thankLead: 'He can thank you for ',
      lastYear: 'Last year I got him ',
      andDid: ' and he ',
      hearRoom: 'He will hear this in ',
      validateGift: 'Tell us what you got him.',
      validateBounce: 'Tell us what he did.',
    },
    ProviderHub: {
      recipient: 'Wife',
      cookie: 'ProviderHub',
      gifts: {
        watch: { label: 'Jewelry', phrase: 'jewelry' },
        wallet: { label: 'A bag', phrase: 'a bag' },
        cologne: { label: 'Perfume', phrase: 'perfume' },
        grill: { label: 'Flowers', phrase: 'flowers' },
        tools: { label: 'A dinner', phrase: 'a dinner' },
        nothing: { label: 'Nothing she would open', phrase: 'anything you wrap' },
        other: { label: 'Something else', phrase: 'another thing' },
      },
      bounces: {
        thanked: { label: 'Thanked you', phrase: 'thanked me' },
        joked: { label: 'Joked it off', phrase: 'joked it off' },
        nothing: { label: 'Said she wanted nothing', phrase: 'said she wanted nothing' },
      },
      rooms: {
        kitchen: 'the kitchen, on an ordinary night',
        car: 'the car, just the two of you',
        dinner: 'after dinner, when the house is quiet',
        together: 'just the two of you, no audience',
        party: 'in front of everyone who loves her',
      },
      faces: {
        quiet: 'She covers her mouth',
        joke: 'She looks up at you',
        again: 'She makes you play it again',
      },
      chips: [
        { text: 'She is still my whole world', kind: 'quality' },
        { text: 'She carried us', kind: 'quality' },
        { text: 'The first time I saw her', kind: 'memory' },
        { text: 'Something I have never said out loud', kind: 'memory' },
      ],
      copy: {
        listen_lead: 'These are songs we already wrote for someone else.',
        listen: 'Yours gets her name, and the thing you never said.',
        gift_title: 'What did you get her last year?',
        gift_watch: 'Jewelry',
        gift_wallet: 'A bag',
        gift_cologne: 'Perfume',
        gift_grill: 'Flowers',
        gift_tools: 'A dinner',
        gift_nothing: 'Nothing she would open',
        gift_other: 'Something else',
        gift_other_label: 'What did you get her?',
        gift_other_placeholder: 'A necklace, a trip, a weekend…',
        gift_other_cta: 'That’s it',
        bounce_title: 'And what did she do?',
        bounce_thanked: 'Thanked you',
        bounce_joked: 'Joked it off',
        bounce_nothing: 'Said she wanted nothing',
        diag_title: 'She would not know how to thank you for a song about her.',
        diag_cta: 'That’s her',
        name_title: 'What do we call her in the song?',
        name_placeholder: 'Her first name',
        name_cta: 'Use this name',
        room_title: 'Where should she hear it first?',
        room_lede: 'Not under the tree. In a room, when she cannot walk away.',
        face_title: 'What do you want to see when it lands?',
        face_quiet: 'She covers her mouth',
        face_joke: 'She looks up at you',
        face_again: 'She makes you play it again',
        chips_title: 'Tap what you never actually said to her.',
        chips_lede: 'These go in the song. Skip anything that isn’t her.',
        missed_placeholder: 'A detail only you would know',
        line_title: 'The one thing you want her to hear.',
        line_placeholder: 'The thing you have been sitting on',
        genre_title: 'What should her song sound like?',
        sound_title: 'Who should sing this to her?',
        contact_title: 'Where do we send her preview?',
        contact_lede: 'Free in ten minutes. Musicians finish it with you.',
        submit: 'Write her song',
      },
      thankNothing: 'She never wanted a thing you could wrap.',
      thankLead: 'She can thank you for ',
      lastYear: 'Last year I got her ',
      andDid: ' and she ',
      hearRoom: 'She will hear this in ',
      validateGift: 'Tell us what you got her.',
      validateBounce: 'Tell us what she did.',
    },
  };

  const form = ui.querySelector('[data-es-form]');
  const back = ui.querySelector('[data-es-pull-back]');
  const vinyl = ui.querySelector('[data-es-gift-vinyl]');
  const disc = ui.querySelector('[data-es-gift-disc]');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let vinylFill = 33;
  let vinylGhost = 33;
  let vinylTween = null;
  let vinylIdleTween = null;
  let vinylIdleTimer = 0;
  let vinylPrimed = false;
  const chipsBox = ui.querySelector('[data-es-pull-chips]');
  const missed = ui.querySelector('[data-es-pull-missed]');
  const nameInput = ui.querySelector('[data-es-pull-name]');
  const lineInput = ui.querySelector('[data-es-pull-line]');
  const errorEl = ui.querySelector('[data-es-error]');
  const thankEl = ui.querySelector('[data-es-gift-thank]');
  const dock = ui.querySelector('[data-es-gift-float]');
  const video = ui.querySelector('[data-es-gift-video]');
  const audio = ui.querySelector('[data-es-gift-audio]');
  const bed = ui.querySelector('[data-es-gift-bed]');
  const hearBtn = ui.querySelector('[data-es-gift-hear]');
  const changeBtn = ui.querySelector('[data-es-gift-change]');
  const picker = ui.querySelector('[data-es-gift-picker]');
  const genreField = ui.querySelector('[data-es-gift-genre-field]');
  const songsEl = ui.querySelector('[data-es-gift-songs]');
  let SONGS = {};
  try {
    SONGS = songsEl ? JSON.parse(songsEl.textContent) : {};
  } catch (err) {
    SONGS = {};
  }
  const otherBox = ui.querySelector('[data-es-gift-other]');
  const otherInput = ui.querySelector('[data-es-gift-other-input]');
  const otherGo = ui.querySelector('[data-es-gift-other-go]');

  const state = {
    skin: 'Generic',
    gift: '',
    other: '',
    bounce: '',
    room: '',
    face: '',
    chips: [],
    genre: '',
    preview: '',
    picked: false,
    index: 0,
  };

  function cookie(name) {
    const m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]+)'));
    return m ? decodeURIComponent(m[1]) : '';
  }

  function setCookie(name, value) {
    document.cookie = name + '=' + encodeURIComponent(value) + ';path=/;max-age=2592000;SameSite=Lax';
  }

  function queryHaystack() {
    let qs;
    try {
      qs = new URLSearchParams(window.location.search || '');
    } catch (err) {
      return '';
    }
    const keys = ['hb_av', 'utm_term', 'utm_campaign', 'utm_content', 'ad_name', 'adset_name', 'omega_ad_name', 'omega_adset_name'];
    const parts = [];
    keys.forEach((key) => {
      const value = qs.get(key);
      if (value) parts.push(value);
    });
    try {
      return decodeURIComponent(parts.join(' ').replace(/\+/g, ' ')).toLowerCase();
    } catch (err) {
      return parts.join(' ').toLowerCase();
    }
  }

  function matchSkin(raw) {
    const key = String(raw || '').toLowerCase();
    if (!key) return '';
    if (
      key.indexOf('providerhub') !== -1 ||
      key.indexOf('provider hub') !== -1 ||
      key.indexOf('ad055') !== -1 ||
      key.indexOf('av-2398d3550938') !== -1
    ) {
      return 'ProviderHub';
    }
    if (
      key.indexOf('gratitudewife') !== -1 ||
      key.indexOf('gratitude wife') !== -1 ||
      key.indexOf('ad056') !== -1 ||
      key.indexOf('ad057') !== -1 ||
      key.indexOf('av-0f0119c25a3a') !== -1
    ) {
      return 'GratitudeWife';
    }
    if (SKINS[raw]) return raw;
    return '';
  }

  function resolveSkin() {
    const fromQuery = matchSkin(queryHaystack());
    if (fromQuery) return fromQuery;
    let qs;
    try {
      qs = new URLSearchParams(window.location.search || '');
    } catch (err) {
      qs = null;
    }
    const adHit = qs && (qs.get('hb_av') || qs.get('utm_content') || qs.get('utm_campaign') || qs.get('ad_name') || qs.get('ad_id') || qs.get('tw_adid'));
    if (adHit) return matchSkin(cookie('_hbav')) || 'Generic';
    return 'Generic';
  }

  function skin() {
    return SKINS[state.skin] || SKINS.Generic;
  }

  function applySkin(id) {
    const next = SKINS[id] ? id : 'Generic';
    state.skin = next;
    const current = skin();
    ui.dataset.skin = next;
    setCookie('_hbav', current.cookie);
    const recipient = form.querySelector('[data-es-pull-recipient]') || form.elements.namedItem('recipient');
    if (recipient) recipient.value = current.recipient;
    Object.keys(current.copy).forEach((key) => {
      const text = current.copy[key];
      ui.querySelectorAll('[data-es-copy="' + key + '"]').forEach((el) => {
        el.textContent = text;
      });
      ui.querySelectorAll('[data-es-ph="' + key + '"]').forEach((el) => {
        el.placeholder = text;
      });
    });
  }

  function keepPlaying() {
    if (!video) return;
    const play = video.play();
    if (play && typeof play.catch === 'function') play.catch(() => {});
  }

  function isMuted() {
    if (audio && !audio.paused && audio.src) return audio.muted;
    if (bed && !bed.paused && bed.src) return bed.muted;
    return !video || video.muted;
  }

  function paintHear() {
    if (!hearBtn) return;
    const on = !isMuted();
    hearBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
    hearBtn.textContent = on ? 'Mute' : 'Unmute';
  }

  function setMuted(muted) {
    if (video) {
      video.muted = true;
    }
    if (audio) {
      audio.muted = muted;
      if (!muted) audio.volume = 1;
    }
    if (bed) {
      bed.muted = muted;
      if (!muted) bed.volume = 1;
    }
    paintHear();
  }

  function stopExtra() {
    if (audio) {
      audio.pause();
      audio.removeAttribute('src');
    }
    if (bed) {
      bed.pause();
      bed.removeAttribute('src');
    }
  }

  function startEl(el, url) {
    if (!el || !url) return;
    const abs = new URL(url, window.location.href).href;
    if (el.src !== abs && el.currentSrc !== abs) {
      el.src = url;
      if (typeof el.load === 'function') el.load();
    }
    el.muted = false;
    el.volume = 1;
    try {
      el.currentTime = 0;
    } catch (err) {}
    const play = el.play();
    if (play && typeof play.catch === 'function') play.catch(() => {});
  }

  function playGenreSong(genre) {
    const song = SONGS[genre];
    if (video) video.muted = true;
    if (!song) {
      stopExtra();
      paintHear();
      return;
    }
    const isAudio = /\.mp3(\?|$)/i.test(song);
    if (isAudio) {
      if (bed) {
        bed.pause();
        bed.removeAttribute('src');
      }
      startEl(audio, song);
    } else {
      if (audio) {
        audio.pause();
        audio.removeAttribute('src');
      }
      startEl(bed, song);
    }
    paintHear();
  }

  function openPicker() {
    if (!picker) return;
    picker.hidden = false;
    picker.classList.add('is-open');
    if (changeBtn) changeBtn.hidden = true;
  }

  function closePicker() {
    if (!picker) return;
    picker.hidden = true;
    picker.classList.remove('is-open');
    if (changeBtn && state.picked && state.preview) {
      changeBtn.hidden = false;
      changeBtn.textContent = state.preview;
    }
  }

  function giftPhrase() {
    const current = skin();
    if (state.gift === 'other' && state.other) return state.other;
    const gift = current.gifts[state.gift];
    return (gift && gift.phrase) || current.gifts.watch.phrase;
  }

  function setPreviewGenre(genre, play) {
    state.preview = genre;
    ui.querySelectorAll('[data-es-gift-genre]').forEach((el) => {
      el.classList.toggle('is-on', el.dataset.esGiftGenre === genre);
    });
    if (play) {
      state.picked = true;
      playGenreSong(genre);
      closePicker();
    }
  }

  function vinylTarget() {
    return Math.max(8, Math.round(((state.index + 1) / PATH.length) * 360));
  }

  function applyVinyl(fill, ghost) {
    vinylFill = fill;
    if (ghost != null) vinylGhost = ghost;
    if (!vinyl) return;
    vinyl.style.setProperty('--gift-fill', fill + 'deg');
    vinyl.style.setProperty('--gift-ghost', vinylGhost + 'deg');
    vinyl.style.setProperty('--gift-arm', 14 + (Math.max(fill, vinylGhost) / 360) * 40 + 'deg');
  }

  function tweenAngle(from, to, ms, onFrame, onDone) {
    let id = 0;
    let stopped = false;
    const start = performance.now();
    const tick = (now) => {
      if (stopped) return;
      const t = Math.min(1, (now - start) / ms);
      const eased = 1 - Math.pow(1 - t, 3);
      onFrame(from + (to - from) * eased);
      if (t < 1) {
        id = window.requestAnimationFrame(tick);
        return;
      }
      onFrame(to);
      if (onDone) onDone();
    };
    id = window.requestAnimationFrame(tick);
    return {
      stop() {
        stopped = true;
        window.cancelAnimationFrame(id);
      },
    };
  }

  function stopTween(tween) {
    if (tween && typeof tween.stop === 'function') tween.stop();
  }

  function stopVinylIdle() {
    window.clearTimeout(vinylIdleTimer);
    stopTween(vinylIdleTween);
    vinylIdleTimer = 0;
    vinylIdleTween = null;
  }

  function scheduleVinylIdle(delay) {
    stopVinylIdle();
    if (!vinyl || reduceMotion.matches || vinylTarget() >= 360) return;
    vinylIdleTimer = window.setTimeout(runVinylIdle, delay);
  }

  function runVinylIdle() {
    if (!vinyl || reduceMotion.matches || document.hidden) {
      scheduleVinylIdle(2800);
      return;
    }
    const base = vinylTarget();
    if (base >= 360) {
      applyVinyl(base, base);
      return;
    }
    vinyl.classList.add('is-cutting');
    vinylIdleTween = tweenAngle(base, 360, 1100, (value) => {
      applyVinyl(base, value);
    }, () => {
      vinylIdleTimer = window.setTimeout(() => {
        vinylIdleTween = tweenAngle(360, base, 700, (value) => {
          applyVinyl(base, value);
        }, () => {
          applyVinyl(base, base);
          vinyl.classList.remove('is-cutting');
          scheduleVinylIdle(2800);
        });
      }, 380);
    });
  }

  function paintVinyl(immediate) {
    if (!vinyl) return;
    const to = vinylTarget();
    stopVinylIdle();
    if (disc) disc.style.transform = 'rotate(' + state.index * 240 + 'deg)';
    stopTween(vinylTween);
    if (immediate || reduceMotion.matches) {
      vinyl.classList.remove('is-cutting');
      applyVinyl(to, to);
      scheduleVinylIdle(500);
      return;
    }
    const from = vinylFill;
    vinyl.classList.add('is-cutting');
    vinylTween = tweenAngle(from, to, 720, (value) => {
      applyVinyl(value, value);
    }, () => {
      applyVinyl(to, to);
      vinyl.classList.remove('is-cutting');
      scheduleVinylIdle(1600);
    });
  }

  function paintThank() {
    if (!thankEl) return;
    const current = skin();
    if (state.gift === 'nothing') {
      thankEl.textContent = current.thankNothing;
      return;
    }
    thankEl.textContent = current.thankLead + giftPhrase() + '.';
  }

  function paintChips() {
    chipsBox.innerHTML = '';
    skin().chips.forEach((chip) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'es-gift__chip';
      btn.textContent = chip.text;
      btn.addEventListener('click', () => {
        const on = btn.classList.toggle('is-on');
        if (on) state.chips.push(chip);
        else state.chips = state.chips.filter((item) => item.text !== chip.text);
        syncBrief();
      });
      chipsBox.appendChild(btn);
    });
  }

  function syncBrief() {
    const current = skin();
    const extra = missed && missed.value.trim() ? missed.value.trim() : '';
    const qualities = state.chips.filter((chip) => chip.kind === 'quality').map((chip) => chip.text);
    const memories = state.chips.filter((chip) => chip.kind === 'memory').map((chip) => chip.text);
    const bounce = current.bounces[state.bounce];
    const lastYear = state.gift
      ? current.lastYear + giftPhrase() + (state.bounce ? current.andDid + ((bounce && bounce.phrase) || state.bounce) : '') + '.'
      : '';
    const roomLine = state.room ? current.hearRoom + (current.rooms[state.room] || state.room) + '.' : '';
    const faceLine = form.querySelector('[data-es-pull-face]').value;
    form.querySelector('[data-es-gift-last]').value = giftPhrase();
    form.querySelector('[data-es-gift-bounce]').value = (bounce && bounce.phrase) || '';
    form.querySelector('[data-es-pull-qualities]').value = qualities.join('. ');
    form.querySelector('[data-es-pull-memories]').value = [lastYear, roomLine, faceLine, ...memories, extra].filter(Boolean).join(' ');
    form.querySelector('[data-es-pull-scene]').value = state.room;
  }

  function go(id, fromBack) {
    const nextIndex = PATH.indexOf(id);
    if (nextIndex < 0) return;
    state.index = nextIndex;
    ui.querySelectorAll('.es-gift__beat').forEach((beat) => {
      beat.classList.toggle('is-on', beat.dataset.beat === id);
    });
    back.hidden = state.index === 0;
    paintVinyl(!vinylPrimed);
    vinylPrimed = true;
    if (!fromBack && id === 'name' && nameInput) nameInput.focus({ preventScroll: true });
    if (!fromBack && id === 'line' && lineInput) lineInput.focus({ preventScroll: true });
  }

  function showError(msg) {
    if (!errorEl) return;
    errorEl.hidden = !msg;
    errorEl.textContent = msg || '';
  }

  function validate(beat) {
    const data = new FormData(form);
    const current = skin();
    if (beat === 'gift' && (!state.gift || (state.gift === 'other' && !state.other))) return current.validateGift;
    if (beat === 'bounce' && !state.bounce) return current.validateBounce;
    if (beat === 'name' && !String(data.get('name') || '').trim()) return root.dataset.errName;
    if (beat === 'room' && !state.room) return 'Pick the room.';
    if (beat === 'face' && !state.face) return 'Pick the face you want.';
    if (beat === 'line' && !String(data.get('message') || '').trim()) return root.dataset.errMessage;
    if (beat === 'genre' && !state.genre && !String(data.get('genre') || '').trim()) return root.dataset.errGenre;
    if (beat === 'sound' && !String(data.get('voice') || '').trim()) return root.dataset.errVoice;
    return '';
  }

  applySkin(resolveSkin());
  paintChips();
  keepPlaying();
  paintHear();
  go('gift');

  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) scheduleVinylIdle(400);
  });

  if (video) {
    video.addEventListener('ended', () => {
      video.currentTime = 0;
      keepPlaying();
    });
  }

  if (hearBtn) {
    hearBtn.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (!state.picked || (picker && !picker.hidden)) {
        openPicker();
        return;
      }
      const mute = !isMuted();
      setMuted(mute);
      if (!mute && state.preview) playGenreSong(state.preview);
    });
  }

  if (changeBtn) {
    changeBtn.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      openPicker();
    });
  }

  ui.querySelectorAll('[data-es-gift-genre]').forEach((btn) => {
    btn.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      setPreviewGenre(btn.getAttribute('data-es-gift-genre'), true);
    });
  });

  ui.querySelectorAll('[data-es-gift-pick]').forEach((btn) => {
    btn.addEventListener('click', () => {
      state.gift = btn.dataset.esGiftPick;
      ui.querySelectorAll('[data-es-gift-pick]').forEach((el) => el.classList.toggle('is-on', el === btn));
      if (state.gift === 'other') {
        if (otherBox) otherBox.hidden = false;
        if (otherInput) otherInput.focus({ preventScroll: true });
        return;
      }
      if (otherBox) otherBox.hidden = true;
      state.other = '';
      paintThank();
      syncBrief();
      go('bounce');
    });
  });

  function commitOther() {
    const value = otherInput && otherInput.value.trim();
    if (!value) return;
    state.gift = 'other';
    state.other = value;
    paintThank();
    syncBrief();
    go('bounce');
  }

  if (otherGo) otherGo.addEventListener('click', commitOther);
  if (otherInput) {
    otherInput.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        commitOther();
      }
    });
  }

  ui.querySelectorAll('[data-es-gift-bounce]').forEach((btn) => {
    btn.addEventListener('click', () => {
      state.bounce = btn.dataset.esGiftBounce;
      ui.querySelectorAll('[data-es-gift-bounce]').forEach((el) => el.classList.toggle('is-on', el === btn));
      syncBrief();
      go('diagnosis');
    });
  });

  ui.querySelectorAll('[data-es-pull-genre]').forEach((btn) => {
    btn.addEventListener('click', () => {
      state.genre = btn.dataset.esPullGenre;
      if (genreField) genreField.value = state.genre;
      ui.querySelectorAll('[data-es-pull-genre]').forEach((el) => el.classList.toggle('is-on', el === btn));
      go('sound');
    });
  });

  ui.querySelectorAll('[data-es-pull-room]').forEach((btn) => {
    btn.addEventListener('click', () => {
      state.room = btn.dataset.esPullRoom;
      ui.querySelectorAll('[data-es-pull-room]').forEach((el) => el.classList.toggle('is-on', el === btn));
      syncBrief();
      go('face');
    });
  });

  ui.querySelectorAll('[data-es-pull-face]').forEach((btn) => {
    btn.addEventListener('click', () => {
      state.face = btn.dataset.esPullFace;
      form.querySelector('[data-es-pull-face]').value = skin().faces[state.face] || '';
      ui.querySelectorAll('[data-es-pull-face]').forEach((el) => el.classList.toggle('is-on', el === btn));
      syncBrief();
      go('chips');
    });
  });

  if (missed) missed.addEventListener('input', syncBrief);

  ui.querySelectorAll('[data-es-pull-next]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const beat = PATH[state.index];
      const missing = validate(beat);
      if (missing) {
        showError(missing);
        return;
      }
      showError('');
      syncBrief();
      const next = PATH[state.index + 1];
      if (next) go(next);
    });
  });

  back.addEventListener('click', () => {
    const prev = PATH[state.index - 1];
    if (prev) go(prev, true);
  });

  ui.querySelector('[data-es-pull-submit]').addEventListener('click', () => {
    syncBrief();
    const missing = validate('genre') || validate('sound') || validate('line');
    const emailError = root.querySelector('[data-es-email-error]');
    const phoneError = root.querySelector('[data-es-phone-error]');
    if (missing) {
      showError(missing);
      return;
    }
    const email = String(new FormData(form).get('email') || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      if (emailError) {
        emailError.hidden = false;
        emailError.textContent = root.dataset.errEmail || 'Enter a valid email.';
      }
      showError(root.dataset.errEmail || 'Enter a valid email.');
      return;
    }
    const phoneValue = String((form.querySelector('[data-es-phone-e164]') || {}).value || '').trim();
    if (!phoneValue) {
      if (phoneError) {
        phoneError.hidden = false;
        phoneError.textContent = root.dataset.errPhone || 'Please enter a valid phone number';
      }
      showError(root.dataset.errPhone || 'Please enter a valid phone number');
      return;
    }
    if (emailError) emailError.hidden = true;
    if (phoneError) phoneError.hidden = true;
    showError('');
    root.dispatchEvent(new CustomEvent('es:generate'));
  });
})();
